// extracted by mini-css-extract-plugin
export default {"card-container":"card_card-container__cplF1","card":"card_card__j+0Fd","name":"card_name__QV-h7"};